import React, {useState, useEffect} from 'react'
import {Navigate} from 'react-router-dom'
import FooterNavMildiou from './MEP/footer-nav-mildiou'
import EnteteMildiou from './MEP/enete-milidou'

function SaisieTraitement() {
  const [goToPDL, setgoToPDL] = useState(false)
  function handleClick(){
    setgoToPDL(true)
  }
  if(goToPDL) {
    return <Navigate push to={`/diagoriskMildiou/menu-plan-de-lutte`}/>
  }
  return (
    <div>
      <EnteteMildiou titre={'Saisir un traitement'}/>
      <FooterNavMildiou/>
      <div className='containerMildiou'> 
        <div style={{marginBottom:'20px'}}><button className='titreMoins colorPrincipal' onClick={handleClick} style={{backgroundColor: 'transparent', border: 'none'}} > {'<'} Revenir </button></div>
        <div className='paragraphe'> En construction </div>
      </div>
    </div>
  )
}

export default SaisieTraitement